import { ReactComponent as RadioEmptyIcon } from "@/components/common/radio/common/radio-empty.svg";
import { ReactComponent as RadioSelectedIcon } from "@/components/common/radio/common/radio-selected.svg";

interface IRadioProps {
  value: string;
  checked: boolean;
}

const Radio: React.FC<IRadioProps> = ({ checked, value }) => {
  return (
    <div className="group flex items-center justify-center">
      <input
        type="radio"
        value={value}
        checked={checked}
        readOnly
        className="hidden"
      />
      {checked ? (
        <RadioSelectedIcon className="text-dark-purple min-w-6 w-6 h-6" />
      ) : (
        <RadioEmptyIcon className="text-slate-gray min-w-6 w-6 h-6 group-hover:text-dark-purple" />
      )}
    </div>
  );
};

export { Radio };
